import { Button } from "@/components/ui/button";
import { ApiError } from "@/lib/types";
import { Link, useRouteError } from "react-router-dom";

const UnhandledException = () => {
  const error = useRouteError() as unknown as ApiError;

  return (
    <div className="max-w-2xl mx-auto w-full pt-[200px] min-h-custom-screen justify-center bg-white text-center min-[42rem]:border-x border-[#e2e2e2]">
      {error?.code && <h1 className="text-4xl font-bold">{error.code}</h1>}
      <p className="text-2xl">
        {error?.message ? error.message : "مشکلی پیش آماده است"}
      </p>
      <p className="mt-3 mb-4">امکان پردازش درخواست شما وجود ندارد. </p>
      <Button className="mt-4" size="sm">
        <Link to="/">بازگشت به صفحه اصلی</Link>
      </Button>
    </div>
  );
};

export default UnhandledException;
